module.exports = __webpack_public_path__ + "img/framenew_box07.648deaef.jpg";